import { Modal, ModalProps } from "antd";

import Close from "./icons/Close";
import "./style.scss";

const CustomModal = (props: ModalProps) => {
  return (
    <Modal
      width={848}
      footer={false}
      className={"custom-modal"}
      centered={true}
      closeIcon={<Close />}
      {...props}
    >
      {props.children}
    </Modal>
  );
};

export default CustomModal;
